"use strict";

import { UIContainer } from "../uiContainer.js";

export class UIRadio extends UIContainer {
    constructor(config) {
        let _onInitialize = config.onInitialize;
        config.onInitialize = undefined;
        
        super(config);

        this.toggles = config.toggles;

        for (let i = 0; i < this.toggles.length; i++) {
            let toggle = this.toggles[i];

            toggle.setParent(this);

            if (toggle.id === undefined) {
                toggle.id = i;
            }

            toggle._onChangedState = function() {
                this.tick.visible = this.toggled;
            };
            toggle._onChangedState();
            toggle._onToggled = () => this._onToggled(toggle.id);

            if (i == config.activeToggle) {
                toggle.toggleOn(false);
                toggle.disable();
            }
        }

        this.onToggle = config.onToggle;

        _onInitialize?.bind(this)(config);
        this.updateNow();
    }

    _onToggled(id) {
        for (let i = 0; i < this.toggles.length; i++) {
            if (i == id) {
                this.toggles[i].disable();
            } else {
                this.toggles[i].enable();
                this.toggles[i].toggleOff(false);
            }
        }

        this.onToggle?.(id);
    }

    enable() {
        this.toggles.forEach(x => {
            if (x.toggled) {
                x.tick.visible = true;
            } else {
                x.interactive = true;
            }
        });
    }
    disable() {
        this.toggles.forEach(x => {
            if (x.toggled) {
                x.tick.visible = false;
            } else {
                x.interactive = false;
            }
        });
    }

    getToggledId() {
        for (let i = 0; i < this.toggles.length; i++) {
            if (!this.toggles[i].toggled) continue;
            return i;
        }
        return -1;
    }
}